const KLAVIYO_BIS_FORM_ID = 'SkSwNU';

/**
 * Open Klaviyo BIS / custom-trigger form.
 * Use _klOnsite.push so it queues before Klaviyo.js finishes loading.
 */
function openKlaviyoForm() {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', KLAVIYO_BIS_FORM_ID]);

  if (typeof window._klOnsite.openForm === 'function') {
    window._klOnsite.openForm([KLAVIYO_BIS_FORM_ID]);
  }

  const { klaviyo } = window;
  if (typeof klaviyo?.openForm === 'function') {
    klaviyo.openForm(KLAVIYO_BIS_FORM_ID);
    return;
  }

  if (klaviyo && typeof klaviyo.push === 'function') {
    klaviyo.push(['openForm', KLAVIYO_BIS_FORM_ID]);
  }
}

/**
 * @param {MouseEvent} event
 */
function onTriggerClick(event) {
  const trigger = event.target instanceof Element ? event.target.closest('.klaviyo-bis-trigger') : null;
  if (!trigger) return;
  if (trigger.closest('.product-form-buttons')) return;

  event.preventDefault();
  openKlaviyoForm();
}

document.addEventListener('click', onTriggerClick);
